<template>
  <div>


<h2 class="goth">När - als / wann / wenn</h2>

<div class="grammatikparagrafbredd leftorient">
<p>Det svenska ordet <b>när</b> motsvaras av tre olika ord i tyskan:
<i><b>als, wann </b></i> och <b><i> wenn</i></b></p>


<br>
    <h4><i>wann</i></h4>
    <div class="quasi-p">Vid <b>frågor</b> och när <b>tidpunkten är osäker</b> används <i>wann</i>.
</div>

<div class="ruta">
    <p><i><b>Wann</b> kommt dein Zug?</i><br><i><b>När</b> kommer ditt tåg?</i></p>


    <p><i>Ich weiß nicht, <b>wann</b> mein Zug kommt.<br>Jag vet inte, <b>när</b> mitt tåg kommer.</i></p>
</div>

<br>
    <h4><i>als</i></h4>
    <div class="quasi-p">När man syftar på något som hänt vid <b>enstaka tillfälle i förfluten tid</b> används <i>als</i>.
</div>

<div class="ruta">
    <p><i><b>Als</b> ich gestern nach Hause kam, war mein Auto weg.<br><b>När</b> jag kom hem igår, var min bil borta.</i></p>
</div>
<div class="mindre">
    <p>"Enstaka händelse" kan emellertid syfta på långa tidsperioder:</p>
<div class="ruta">
    <p><i><b>Als</b> ich Kind war, hatte ich einen Hund.<br><b>När</b> jag var barn, hade jag en hund.</i></p>
</div>
</div>

<br>
<h4><i>wenn</i></h4>
<div class="quasi-p">Vid något som hänt eller händer vid <b>upprepande tillfällen</b>,
    <b>framtid</b> och övriga fall som inte rymms under de två ovanstående används <i>wenn</i>.</div>


<div class="ruta">
    <p><i>Ich bin immer sehr müde, <b>wenn</b> ich zur Arbeit fahre.<br>Jag är alltid väldigt trött, <b>när</b> jag åker till jobbet.</i></p>

    <p><i>Ich rufe dich an, <b>wenn</b> ich fertig bin.<br>Jag ringer dig, <b>när</b> jag är klar.</i></p>


</div>
</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "när als wann wenn"
            }
        ]
    }
}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
